import React from "react";
import Translate from "react-translate-component";
import TranslateWithLinks from "../../Utility/TranslateWithLinks";
export const LimitOrderCancel = ({
  op,
  changeColor,
  fromComponent,
  linkToAccount
}) => {
  changeColor("cancel");

  if (fromComponent === "proposed_operation") {
    return /*#__PURE__*/React.createElement("span", null, linkToAccount(op[1].fee_paying_account), "\xA0", /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.limit_order_cancel"
    }), "\xA0#", op[1].order.substring(4));
  } else {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TranslateWithLinks, {
      string: "operation.limit_order_cancel",
      keys: [{
        type: "account",
        value: op[1].fee_paying_account,
        arg: "account"
      }],
      params: {
        order: op[1].order.substring(4)
      }
    }));
  }
};